import(/* webpackMode: "eager", webpackExports: ["PostHogClient"] */ "/app/apps/web/src/components/PostHogClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/apps/web/src/components/theme/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserNav"] */ "/app/apps/web/src/components/ui/user-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/providers/sessionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.3.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/app-dir/link.js");
